import { Badge, Button, Dropdown, Form } from "react-bootstrap";
import {
  FiCalendar,
  FiClock,
  FiCopy,
  FiEdit,
  FiEye,
  FiHeadphones,
  FiMail,
  FiMessageSquare,
  FiMoreVertical,
  FiPhone,
  FiPlusSquare,
  FiStar,
  FiX,
} from "react-icons/fi";
import EditContactInformation from "./EditContactInformation";
import UseToggle from "../../Hooks/UseToggle";
import EditAboutMe from "./EditAboutMe";
import EditYourProfile from "./EditYourProfile";
import SetStatus from "./SetStatus";
import { userServices } from "../../APIServices/UserData/userServices";
import { useEffect, useState } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import { BsCake2 } from "react-icons/bs";

const ProfileDetails = ({ userId, onClose }) => {
  const toggles = UseToggle();
  let [memberData, setMemberData] = useState("")
  const [time, setTime] = useState("");

  const getSingleMember = async () => {
    let data = await userServices.getSingleMember(userId)
    setMemberData(data?.data || "")
  }

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      let hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12 || 12;

      setTime(`${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  function formatDateWithAge(dateValue) {
    const date = new Date(dateValue);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const formattedDate = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
    const now = new Date();
    let yearsAgo = now.getFullYear() - date.getFullYear();
    const hasHadAnniversary =
      now.getMonth() > date.getMonth() ||
      (now.getMonth() === date.getMonth() && now.getDate() >= date.getDate());

    if (!hasHadAnniversary) {
      yearsAgo--;
    }
    return `${formattedDate} (${yearsAgo} years ago)`;
  }

  function getCurrentAnniversary(joiningDate) {
    const startDate = new Date(joiningDate);
    const today = new Date();

    let years = today.getFullYear() - startDate.getFullYear();

    const hasPassedThisYear =
      today.getMonth() > startDate.getMonth() ||
      (today.getMonth() === startDate.getMonth() &&
        today.getDate() >= startDate.getDate());

    if (!hasPassedThisYear) {
      years--;
    }
    const anniversaryNumber = years + 1;

    return anniversaryNumber;
  }

  function isBirthdayToday(dob) {
    const birthDate = new Date(dob);
    const today = new Date();

    return (
      birthDate.getDate() === today.getDate() &&
      birthDate.getMonth() === today.getMonth()
    );
  }

  useEffect(() => {
    if (userId) {
      getSingleMember()
    }
  }, [userId]);
  return (
    <>
      <aside className="thread-panel">
        {/* Header */}
        <div className="thread-header border-bottom">
          <strong>{memberData?.name}'s Profile</strong>
          <FiX onClick={onClose} />
        </div>

        {/* Parent Message */}
        <div className="overflow-auto" style={{ height: "calc(100vh - 56px)" }}>
          <div className="thread-parent border-bottom">
            <div className="text-center w-100">
              <img
                className="rounded-2 border mb-4"
                src={memberData?.icon || "https://password-super.s3.ap-south-1.amazonaws.com/icons/useryellow.png"}
                alt={memberData?.name}
                style={{ height: 200 }}
              />
              <div className="fw-bold section-title justify-content-center mb-1">
                {memberData?.name} {memberData?.own && "(You)"}
                {memberData?.own &&
                  <Form.Label
                    className="fw-bold hstack gap-2 CP m-0 ms-3"
                    title="Edit Contact"
                    onClick={() => toggles.setToggle2()}
                    style={{ fontSize: 14 }}
                  >
                    <FiEdit /> Edit
                  </Form.Label>
                }
              </div>
              <div className="small section-title justify-content-center mb-1">
                {memberData.designationName}
              </div>
              <Badge
                className="rounded-1 text-capitalize"
                bg={
                  memberData.liveStatus === "online"
                    ? "success"
                    : memberData.liveStatus === "away"
                      ? "warning"
                      : "secondary small rounded-1"
                }
              >
                {memberData.liveStatus}
              </Badge>
              <div className="small section-title justify-content-center mt-1 mb-1">
                <FiClock className="me-1" /> {time} local time
              </div>
              <div className="fw-bold section-title hstack gap-2 justify-content-center mb-3">
                <div className="border border-success bg-success rounded-1 px-2 text-white">
                  {getCurrentAnniversary(memberData?.createdAt)} anniversary 🎉
                </div>
                {isBirthdayToday(memberData?.createdAt) &&
                  <div className="border border-success bg-success rounded-1 px-2 text-white">
                    Happy BirthDay 🎉
                  </div>
                }
              </div>
              <div className="hstack gap-2 justify-content-between">
                {memberData?.own ?
                  <>
                    <Button
                      className="w-100 p-1 rounded-1 hstack gap-2 justify-content-center"
                      style={{ fontSize: 13 }}
                      variant="outline-primary"
                      onClick={() => toggles.setToggle3()}
                    >
                      <FiStar /> Set a status
                    </Button>
                    <Dropdown align="end" className="w-100">
                      <Dropdown.Toggle as="span" className="CP" id="team-dropdown">
                        <Button
                          className="w-100 p-1 rounded-1 hstack gap-2 justify-content-center"
                          style={{ fontSize: 13 }}
                          variant="outline-primary"
                        >
                          <FiEye /> View as
                        </Button>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          style={{ fontSize: 13 }}
                          title="Copy display Name"
                          className="hstack gap-2"
                        >
                          A coworker at Workbridge
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown align="end">
                      <Dropdown.Toggle as="span" className="CP" id="team-dropdown">
                        <Button
                          className="p-1 rounded-1"
                          style={{ fontSize: 13 }}
                          variant="outline-primary"
                        >
                          <FiMoreVertical />
                        </Button>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          style={{ fontSize: 13 }}
                          title="Copy display Name"
                          className="hstack gap-2"
                        >
                          Copy display Name : @Roop
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item
                          style={{ fontSize: 13 }}
                          title="View preferences"
                          className="hstack gap-2"
                        >
                          View preferences
                        </Dropdown.Item>
                        <Dropdown.Item
                          style={{ fontSize: 13 }}
                          title="Account settings"
                          className="hstack gap-2"
                        >
                          Account settings
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item
                          style={{ fontSize: 13 }}
                          title="Set yoursef away"
                          className="hstack gap-2"
                        >
                          Set yoursef away
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item
                          style={{ fontSize: 13 }}
                          title="Copy member id"
                          className="hstack gap-2"
                        >
                          Copy member id
                        </Dropdown.Item>
                        <Dropdown.Item
                          style={{ fontSize: 13 }}
                          title="Copy link to profile"
                          className="hstack gap-2"
                        >
                          Copy link to profile
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </>
                  :
                  <>
                    <Button
                      className="w-100 p-1 rounded-1 hstack gap-2 justify-content-center"
                      style={{ fontSize: 13 }}
                      variant="outline-primary"
                    >
                      <FiMessageSquare /> Message
                    </Button>
                    <Button
                      className="w-100 p-1 rounded-1 hstack gap-2 justify-content-center"
                      style={{ fontSize: 13 }}
                      variant="outline-primary"
                    >
                      <FiHeadphones /> Meeting
                    </Button>
                    <Button
                      className="p-1 rounded-1"
                      style={{ fontSize: 13 }}
                      variant="outline-primary"
                    >
                      <FiMoreVertical />
                    </Button>
                  </>
                }
              </div>
            </div>
          </div>
          <div className="thread-parent border-bottom">
            <Form.Group className="w-100">
              <Form.Group className="hstack justify-content-between w-100">
                <Form.Label className="fw-bold" style={{ fontSize: 14 }}>
                  Contact information
                </Form.Label>
              </Form.Group>
              <div className="hstack gap-2 mb-2">
                <FiMail
                  size={30}
                  className="p-1 bg-primary-subtle border rounded-1"
                />
                <div>
                  <h6 className="m-0 fw-bold section-title">Email Address</h6>
                  <p className="m-0 section-title">
                    <a href={`mailto: ${memberData?.email}`}>{memberData?.email}</a>{" "}
                    <FiCopy className="ms-2 CP" title="Copy Email" />
                  </p>
                </div>
              </div>
              {memberData?.phone &&
                <div className="hstack gap-2 mb-2">
                  <FiPhone
                    size={30}
                    className="p-1 bg-primary-subtle border rounded-1"
                  />
                  <div>
                    <h6 className="m-0 fw-bold section-title">Phone Number</h6>
                    <p className="m-0 section-title">
                      <a href={`tel: ${memberData?.phone}`}>{memberData?.phone}</a>{" "}
                      <FiCopy className="ms-2 CP" title="Copy Phone" />
                    </p>
                  </div>
                </div>
              }
            </Form.Group>
          </div>
          <div className="thread-parent border-bottom">
            <Form.Group className="w-100">
              <Form.Group className="hstack justify-content-between w-100">
                <Form.Label className="fw-bold" style={{ fontSize: 14 }}>
                  About me
                </Form.Label>
              </Form.Group>
              {memberData?.dateOfBirth &&
                <div className="hstack gap-2 mb-2">
                  <BsCake2
                    size={30}
                    className="p-1 bg-primary-subtle border rounded-1"
                  />
                  <div>
                    <h6 className="m-0 fw-bold section-title">Date of Birth</h6>
                    <p
                      className="m-0 section-title text-primary fw-bold CP"
                      title="Update Date"
                      onClick={() => toggles.setToggle1()}
                    >
                      <u>{formatDateWithAge(memberData?.dateOfBirth)}</u>
                    </p>
                  </div>
                </div>
              }
              <div className="hstack gap-2 mb-2">
                <FiCalendar
                  size={30}
                  className="p-1 bg-primary-subtle border rounded-1"
                />
                <div>
                  <h6 className="m-0 fw-bold section-title">Join date</h6>
                  <p
                    className="m-0 section-title text-primary fw-bold CP"
                    title="Update Date"
                    onClick={() => toggles.setToggle1()}
                  >
                    <u>{formatDateWithAge(memberData?.createdAt)}</u>
                  </p>
                </div>
              </div>
            </Form.Group>
          </div>
        </div>
      </aside>
      <EditContactInformation
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title="Edit Contact Information"
      />
      <EditAboutMe
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title="Edit Contact Information"
      />
      <EditYourProfile
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title="Edit Your Profile"
      />
      <SetStatus
        Show={!toggles.toggle3}
        Hide={toggles.setToggle3}
        Title="Set a status"
      />
    </>
  );
};

export default ProfileDetails;
